var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContinue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14C4.86739 14 4.74021 13.9473 4.64645 13.8536C4.55268 13.7598 4.5 13.6326 4.5 13.5V2.5C4.50004 2.4122 4.5232 2.32596 4.56714 2.24995C4.61109 2.17395 4.67428 2.11085 4.75035 2.06701C4.82642 2.02317 4.91269 2.00014 5.00049 2.00022C5.08829 2.00031 5.17452 2.02351 5.2505 2.0675L14.7505 7.5675C14.8263 7.61145 14.8892 7.67454 14.9329 7.75044C14.9766 7.82635 14.9996 7.91241 14.9996 8C14.9996 8.08759 14.9766 8.17365 14.9329 8.24956C14.8892 8.32546 14.8263 8.38855 14.7505 8.4325L5.2505 13.9325C5.17439 13.9766 5.08798 13.9999 5 14ZM5.5 3.367V12.633L13.5 8L5.5 3.367ZM2 2H3V14H2V2Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinue);
export default __webpack_public_path__ + "static/media/Continue.3533863fd24aff8de3381817043761ad.svg";
export { ForwardRef as ReactComponent };